<template>
	<div id="right">
		<div class="cc-header">学生请假</div>
		<dv-scroll-board :config="config" class="leavelist" />
	</div>
</template>
		
<script>
	var storage = window.localStorage;
	var orgId = storage.getItem("orgId");
	export default {
		data() {
			return {
				config: {}
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData(); // 修改数据date
			}, 1000 * 60 * 60);
		},
		methods: {
			initData() {
				let _this = this;
				this.$http.get("/dataView/headmaster/studentLeave?orgId=" + orgId).then(res => {
					if (res.data.code === 200) {
						var result = [];
						for (let i = 0; i < res.data.result.length; i++) {
							result.push([res.data.result[i].clazzName, res.data.result[i].studentName]);
						}
						if(result.length > 0){
							_this.config = {
								header: ['班级', '姓名'],
								data: result,
								headerBGC: '',
								oddRowBGC: 'none',
								evenRowBGC: 'none',
								headerHeight: 30,
								rowNum: 3, //表格行数
								waitTime: 2000,
								align: ['center', 'center']
							};
						}else{
							_this.config = {
								data: [['<div class="noneData">暂无请假</div>']],
								evenRowBGC: 'none',
								rowNum: 1,
								align: ['center']
							};
						}
					}
				});
			}
		}
	};
</script>

<style lang="scss">
	#right {
		height: 100%;
		.leavelist {
			padding: 0.15rem 2%;
			width: 100%;
			height: 70%;
		}
		
		.leavelist .header {
			background: url("../../assets/img/hm_tblbg.png") center repeat-y;
			background-size: 100%;
			color: #00f0ff;
			font-size: 0.2rem;
			font-weight: bold;
		}
		
		.leavelist .row-item {
			background: url("../../assets/img/hm_tblbg.png") bottom no-repeat;
			background-size: 100%;
			color: #fff;
			font-size: 0.2rem;
		}
	}
</style>